import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]

  static targets = [
    "additionalDiscount",
    "baseCommission",
    "commissionDiscount",
    "commissionFields",
    "discountedCommission",
    "discountedPrice",
    "priceDiscount"
  ]

  static outlets = ["admin--quotes--form", "admin--quotes--marketing-package"]

  static values = { saved: Boolean }

  #fullMarketingPackage = false
  #baseCommissionChosen = false

  adminQuotesFormOutletConnected() {
    this.basePriceChanged()
    this.auctionTypeChanged()
    if (this.hasAdminQuotesMarketingPackageOutlet) this.marketingOffersChanged()
  }

  adminQuotesMarketingPackageOutletConnected() {
    if (this.hasAdminQuotesFormOutlet) this.marketingOffersChanged()
  }

  // outlet API: called by admin--quotes--form via the option outlet
  basePriceChanged() {
    this.priceDiscountTarget.setAttribute("max", this.#form.basePrice)
    this.updateDiscountedPrice()
  }

  // outlet API: called by admin--quotes--form via the option outlet
  auctionTypeChanged() {
    this.#toggleCommissionFields()
  }

  // outlet API: called by admin--quotes--form via the option outlet
  // The marketing packages depend on the auction's year, the agency's country and the offer type, the services on the
  // year and country.
  marketingOffersChanged() {
    this.adminQuotesMarketingPackageOutlet.updatePackages(this.#form.year, this.#form.country, this.#form.offerType)
  }

  // outlet API: called by admin--quotes--form via the option outlet
  // A new option starts at the base commission of the agency's country until the admin picks one.
  countryChanged() {
    const commission = this.#form.defaultBaseCommission
    if (this.savedValue || this.#baseCommissionChosen || commission === undefined) return

    this.baseCommissionTarget.value = commission.toFixed(1)
    this.updateDiscountedCommission()
  }

  chooseBaseCommission() {
    this.#baseCommissionChosen = true
  }

  updateDiscountedPrice() {
    const discountedPrice = this.#form.basePrice - parseFloat(this.priceDiscountTarget.value)
    this.discountedPriceTarget.value = discountedPrice
    this.additionalDiscountTarget.setAttribute("max", discountedPrice)
  }

  updateDiscountedCommission() {
    this.discountedCommissionTarget.value = this.#baseCommission - this.#commissionDiscount
  }

  // Full marketing waives the online turnover commission, so the commission fields go with it.
  marketingPackageChanged({ detail: { fullPackage } }) {
    this.#fullMarketingPackage = fullPackage
    this.#toggleCommissionFields()
  }

  get #form() {
    return this.adminQuotesFormOutlet
  }

  get #commissionDiscount() {
    return parseFloat(this.commissionDiscountTarget.value)
  }

  get #baseCommission() {
    return parseFloat(this.baseCommissionTarget.value)
  }

  #toggleCommissionFields() {
    const isDisabled = this.#form.auctionType === "event" || this.#fullMarketingPackage
    this.commissionFieldsTarget.classList.toggle(this.hiddenClass, isDisabled)
    this.commissionFieldsTarget.disabled = isDisabled
  }
}
